export const FORM_VALIDATION_RULES = {
  required: { required: true, message: '' },
  requiredUsername: { required: true, message: 'Please add your username' },
  requiredPassword: { required: true, message: 'Please add your password' },
  phone: {
    pattern: '^\\+?[0-9]{8,15}$',
    message: 'Please enter a valid phone number',
  },
  email: {
    type: 'email',
    message: 'Please enter a valid email address',
  },
};
